import { Settings } from '@lightningjs/sdk'
import { Flo } from '../../types/flo-auth-api'
import { getUserData } from '../../utils/authentication'
import { getPaymentsUrl } from '../../utils/network'
import { isStagingEnabled } from '../../utils/settingsUtils'
import { AppConfig } from '../appConfig'

export class VizioSubscriptionService implements ISubscriptionService {
  protected FLO_VIZIO_PAY_URL = getPaymentsUrl()

  initialize() {
    const appKeyId = Settings.get(
      'app',
      isStagingEnabled() ? 'env.APP_VIZIO_APP_KEY_ID_STAGING' : 'env.APP_VIZIO_APP_KEY_ID_PROD',
    )

    const backendService = {
      backendUrl: `${this.FLO_VIZIO_PAY_URL}/vizio`,
      signChallenge: async function (challenge: string): Promise<string> {
        const data = {
          challenge,
        }
        const res = await fetch(`${this.backendUrl}/signChallenge`, {
          headers: {
            'content-type': 'application/json',
          },
          method: 'POST',
          body: JSON.stringify(data),
        })

        return await res.text()
      },
    }

    // Register the signature generating callback and partner's App Key ID
    window.VIZIO.Account.registerPartner(
      backendService.signChallenge.bind(backendService),
      appKeyId,
    )
  }

  getType(): string {
    return 'vizio'
  }

  async getProducts(): Promise<ProductList> {
    const plans = await VIZIO.Account.getPlans()
    const productList: ProductList = plans?.data.map((product) => ({
      currency: 'USD', // only US
      description: product.description,
      title: product.name,
      price: product.price,
      id: product.planCode,
    }))

    return productList
  }

  async buyProduct(product: IProduct): Promise<Purchase> {
    const userId = getUserData()?.user_id?.toString()

    try {
      const purchaseResult: VIZIO.Account.SVODPurchaseDetails =
        await VIZIO.Account.startSVODPurchase(product?.id, userId)
      if (purchaseResult?.data?.subscriptionId) {
        console.log('successful purchase result', purchaseResult)
      }

      return { invoiceId: purchaseResult?.data?.subscriptionId }
    } catch (error) {
      console.error('Vizio startSVODPurchase error: ', error)
    }

    return Promise.resolve(null)
  }

  async createSubscription(
    offer: Flo.Offers.OffersResponseData,
    subscriptionId: string,
  ): Promise<Flo.Payments.SubscriptionResponse> {
    const userData = getUserData()
    return await AppConfig.shared.authService.createSubscription({
      type: AppConfig.shared.subscriptionService.getType(),
      vizioIAPSubscriptionId: subscriptionId,
      offering: offer.id,
      user: userData.user_id,
    })
  }
}
